import { createWidget } from '@funtech-int/rival';
import { ComponentProps } from 'react';

import PurchasesSelection from './components/PurchasesSelection/PurchasesSelection';

export const purchasesSelectionWidget = createWidget<
    unknown,
    ComponentProps<typeof PurchasesSelection>
>();
